<template>
    <div>
        <p class="pause-question" v-text="question"></p>
        <button v-text="updateSubscriptionText"
                @click.prevent="updateSubscription" class="btn btn--primary btn--full-width pause-primary--button">
        </button>
        <button v-text="continueToPauseText"
                @click.prevent="continueToPauseSubscription" class="btn btn--secondary-black btn--full-width pause-secondary--button">
        </button>
        <p class="error pause-error--message" v-if="errorMessage" v-text="errorMessage"></p>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { CSPageEvents } from '@/helpers/GAHelpers';

export default {
    name: 'PauseQuestion',
    props: {
        question: {
            type: String,
        },
        updateSubscriptionText: {
            type: String,
        },
        errorMessage: {
            type: String,
        },
        stageId: {
            type: String,
        },
    },
    methods: {
        updateSubscription() {
            CSPageEvents(`${this.stageId}-accepted`);
            this.$emit('input', 'update');
        },
        continueToPauseSubscription() {
            CSPageEvents(`${this.stageId}-paused`);
            this.$emit('input', 'continue');
        },
    },
    computed: {
        ...mapGetters({
            isPauseFlow: 'account/getIsPauseFlow',
        }),
        continueToPauseText() {
            return this.isPauseFlow ? this.$t('PAUSE_DELIVERIES_NO_THANKS') : this.$t('CANCEL_DELIVERIES_NO_THANKS');
        },
    },
};
</script>
<style lang="scss" scoped>
    .pause-question {
        margin: 15px 0;
        text-align: left;
    }
    .pause-primary--button {
        margin: 10px 0 5px;
        background: #262323;
        height: 40px;
        padding-top: 0px;
        padding-bottom: 0px;
        width: 100%;
    }
    .pause-secondary--button {
        margin: 5px 0 20px;
        height: 40px;
        padding-top: 0px;
        padding-bottom: 0px;
        width: 100%;
    }
</style>
